module.exports = __webpack_public_path__ + "img/second-avater-2.34d12f1.png";